import { Component, OnInit,Inject,ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { WebCompProfileService } from 'app/main/pagina/web-comp-profile/web-comp-profile.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { lang_webProfile } from 'app/idiomas/i18n/webProfile/webProfile.lang';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-modal-comp-profile',
  templateUrl: './modal-comp-profile.component.html',
  styleUrls: ['./modal-comp-profile.component.scss']
})
export class ModalCompProfileComponent implements OnInit {
raisonText="";
ramdomText="";
ramdomCodigo:any;
acciones = [
  { id: 'EnlaceWCP', nombre: 'Copiar enlace para ingresar al perfil de empresa', icono: 'file_copy', bloqueado: false, funcion: 'copyEnlace'},
  { id: 'ClaveWCP', nombre: 'Copiar clave para ingresar al perfil de empresa', icono: 'file_copy', bloqueado: false, funcion: 'copyClave'},
];
  constructor(
        @Inject(MAT_DIALOG_DATA) public datos: any,
        public dialogRef: MatDialogRef<ModalCompProfileComponent>,
        private wcp: WebCompProfileService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private translateSrv: TranslateService,
  ) {
    lang_webProfile.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit(){
    console.log("datos",this.datos);
if (this.datos.tipo=='StatusVisi') {
  let r = Math.random().toString(36).substring(7);
  console.log("cadena de datos aleatorios: ",r);
  let codigo=r;
  this.ramdomCodigo=r ;
}
  }

  salir() {
    this.dialogRef.close({
      cambios:false,
    });
  }

  updateStatusNoPublicWebComProfile(){
    let datos={
      productoId:this.datos.productoId,
      visibility:this.datos.status,
      reason:this.raisonText,
    }
    console.log('raisonText',this.raisonText);
if (this.raisonText!="") {
  this.wcp.updateStatusNoPublicWebComProfile(datos).subscribe( (respuestaStatus:any) => {
      console.log('respuestaStatus',respuestaStatus);
      if(respuestaStatus.success == true){
      this.dialogRef.close({
        cambios:true,
      });
        }
      });

}else{
  Swal.fire({
    icon: 'warning',
    title: this.translateSrv.instant('WEB_COMPANY_PROFILE.MODAL.RAISON_OBLIG'),
    confirmButtonText: this.translateSrv.instant('WEB_COMPANY_PROFILE.MODAL.BTN_CONT'),
  });
}
  }

  updateStatusPublicWebComProfile(){
    let datos={
      productoId:this.datos.productoId,
      visibility:true,
      reason:"",
      ok:true,
    }
    console.log('raisonText',this.raisonText);
if (this.ramdomText==this.ramdomCodigo) {
  this.wcp.updateStatusNoPublicWebComProfile(datos).subscribe( (respuestaStatus:any) => {
      console.log('respuestaStatus',respuestaStatus);
      if(respuestaStatus.success){
      this.dialogRef.close({
        cambios:true,
      });
        }
      });

}else{
  Swal.fire({
    icon: 'warning',
    title: 'El codigo  no coincide ',
    // title: this.translateSrv.instant('WEB_COMPANY_PROFILE.MODAL.RAISON_OBLIG'),
    confirmButtonText: this.translateSrv.instant('WEB_COMPANY_PROFILE.MODAL.BTN_CONT'),
  });
}
  }

  copyEnlace(){
    console.log('this.getdataWPCPassword',this.datos.WPCPEnlace);
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value =  `${this.datos.WPCPEnlace}`;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    Swal.fire({
      icon: 'success',
      title: this.translateSrv.instant('ACCIONES.MODALES.URL'),

      confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
    });
  }

  copyClave(){
    console.log('this.getdataWPCPassword',this.datos.WPCPassword);
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value =  `${this.datos.WPCPassword}`;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    Swal.fire({
      icon: 'success',
      title: this.translateSrv.instant('ACCIONES.MODALES.URL_CLA'),

      confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
    });
  }
}
